import axios from 'axios';
import { on } from 'delegated-events';
import { lmsUrl, currentHref, offset } from './def';
// import './external/pristine';
import './pristine';

function validateFiles() {
  if (this.value) {
    const data = new FormData();

    const form = this.closest('form');
    const fileInput = this;
    const fileBtn = form.querySelector('.c-form-btnFile');
    const messageContainer = form.querySelector('.c-form-filename');

    const files = [...this.files];
    files.forEach((file, index) => {
      data.append('file', file);
    });

    axios
      .post('../include/helpers/upload.php', data)
      .then((response) => {
        const { data } = response;
        if (data.status == 'error') {
          fileBtn.textContent = 'Załącz CV';
          messageContainer.textContent = data.msg;
          fileInput.value = '';
          fileInput.parentNode.replaceChild(fileInput.cloneNode(true), fileInput);
        } else {
          messageContainer.textContent = '';
          fileBtn.textContent = data.filename_input;
        }
      })
      .catch((error) => {
        fileBtn.textContent = 'Załącz CV';
        messageContainer.textContent = data.msg;
        fileInput.value = '';
        fileInput.parentNode.replaceChild(fileInput.cloneNode(true), fileInput);
      });
  }
}

function getErrors(validatorResult) {
  return error;
}

function toggleHiddenInfo() {
  const form = this.closest('form');
  const hiddenInfos = form.querySelectorAll('.js-form-administratorInfo');
  this.textContent = this.textContent == 'Rozwiń' ? 'Zwiń' : 'Rozwiń';
  [...hiddenInfos].forEach((el) => {
    el.classList.toggle('is-hidden');
  });
}

on('change', 'input[type="file"]', validateFiles);

on('click', '.c-form-administratorInfo-showmore', toggleHiddenInfo);

on('submit', '.c-form', function (e) {
  e.preventDefault();
  const formWrap = this.parentNode;
  const form = this;

  const containerError = form.querySelector('.c-form-error');
  const containerMsg = formWrap.querySelector('.c-form-msg');

  const submitBtn = form.querySelector('.js-form-send');

  const phoneInput = form.querySelector('input[type="tel"]');
  const emailInput = form.querySelector('input[type="email"]');

  const isPhoneForcedRequired = form.classList.contains('js-lmsform-phonerequired');
  const isLmsForm = form.classList.contains('js-lmsform');

  const validator = new Pristine(form, {
    errorClass: 'error',
    classTo: 'c-form-item',
  });

  console.log(validator);

  const phonePattern = new RegExp('^\\d{9}$');

  validator.addValidator(
    phoneInput,
    (value, elem) => {
      if (!isPhoneForcedRequired) {
        return value ? value.match(phonePattern) : true;
      }
      return value.match(phonePattern);
    },
    'Prosimy o podanie 9-cyfrowego numeru telefonu.'
  );

  if (!isPhoneForcedRequired) {
    validator.addValidator(
      phoneInput,
      (value, elem) => !!(value.length || emailInput.value.length),
      'Prosimy uzupełnić jedno z pól: telefon/email.'
    );
    validator.addValidator(
      emailInput,
      (value, elem) => !!(value.length || phoneInput.value.length),
      'Prosimy uzupełnić jedno z pól: telefon/email.'
    );
  } else {
    validator.addValidator(
      phoneInput,
      (value, elem) => !!value.length,
      'Prosimy uzupełnić wszystkie pola.'
    );
  }

  const formValid = validator.validate();
  const formErrors = validator.getErrors();

  console.log(formErrors);
  const errorMsg = formErrors.length ? formErrors[0].errors[0] : '';
  containerError.textContent = errorMsg;

  if (formValid) {
    const data = new FormData(form);
    const formName = form.getAttribute('name');

    submitBtn.disabled = true;
    form.classList.add('is-sending');
    axios({
      method: 'post',
      url: isLmsForm ? lmsUrl : `/include/form/${formName}.php`,
      data,
    })
      .then((response) => {
        const { data } = response;
        const { status, msg = 'Wystąpił nieznany błąd' } = data;

        if (status == 200) {
          containerMsg.innerHTML = msg;
          form.remove();
          window.scroll({
            top: offset(formWrap).top,
          });
        } else {
          containerError.textContent = msg;
        }

        submitBtn.disabled = false;
        form.classList.remove('is-sending');

        if (typeof window.gtag === 'function') {
          window.gtag('event', 'Wysłanie Formularza', {
            event_category: 'Formularze',
            event_label: `Formularz - ${currentHref}`,
          });
        }
      })
      .catch((error) => {
        containerError.textContent = error;
      });
  }
});
